import { OrdersIcon } from '@/components/icons';
import { Button } from 'antd';
import { useNavigate } from 'react-router-dom';

import { useNewOrderCount } from '@/lib/use-new-orders';

/**
 * "2 new orders" in the header, and nothing at all when there are none.
 *
 * Absent rather than zero, like the connection pill beside it. A row of
 * indicators that are usually showing nothing teaches people to stop reading
 * the row; one that only appears when it has something to say gets read.
 *
 * It is a BUTTON, not a label. An unaccepted order is the one state in this
 * app where nothing moves until somebody acts, so the thing announcing it
 * should also be the way to go and deal with it - a count you have to go and
 * find the page for is a count that gets ignored at a busy counter.
 *
 * Undefined while the first count is still in flight: the header must not
 * flash "0 new orders" and then a number on every load.
 */
export function NewOrdersPill() {
  const navigate = useNavigate();
  const count = useNewOrderCount();

  if (!count) return null;

  return (
    <Button
      danger
      type="primary"
      icon={<OrdersIcon />}
      onClick={() => navigate('/orders')}
      /*
       * Announced when the number changes, so somebody using a screen reader
       * at the counter hears an order arrive rather than discovering it on
       * their next pass through the sidebar. `polite` - it waits for them to
       * finish what they are reading.
       */
      aria-live="polite"
    >
      <span data-numeric>
        {count} new {count === 1 ? 'order' : 'orders'}
      </span>
    </Button>
  );
}
